import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { getInfomationAccountFromToken } from '../../../utils/helper';
import User from './user-dropdown/UserDropdown';

const Header = () => {
    const location = useLocation();
    const account = getInfomationAccountFromToken();
    const isAdmin = account?.role?.toLowerCase().includes('admin') || account?.role?.toLowerCase().includes('publisher') || account?.role?.toLowerCase().includes('manager');
    const isSuperAdmin = account?.role?.toLowerCase().includes('admin');
    const isEditor = account?.role?.toLowerCase().includes('editor');
    const isEditorOrAdmin = isAdmin || isEditor;

    // States to control hover/click dropdowns
    const [activeDropdown, setActiveDropdown] = useState(null);

    const handleMouseEnter = (name) => {
        setActiveDropdown(name);
    };

    const handleMouseLeave = () => {
        setActiveDropdown(null);
    };

    const toggleSidebar = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const body = document.body;
        const width = window.innerWidth;
        if (width < 992) {
            if (body.classList.contains('sidebar-open')) {
                body.classList.remove('sidebar-open');
                body.classList.add('sidebar-collapse');
            } else {
                body.classList.add('sidebar-open');
                body.classList.remove('sidebar-collapse');
            }
        } else {
            body.classList.remove('sidebar-open');
            if (body.classList.contains('sidebar-collapse')) {
                body.classList.remove('sidebar-collapse');
            } else {
                body.classList.add('sidebar-collapse');
            }
        }
        console.log('Sidebar toggled: open =', body.classList.contains('sidebar-open'), 'collapsed =', body.classList.contains('sidebar-collapse'));
    };

    return (
        <nav className="main-header navbar navbar-expand navbar-dark" style={{ zIndex: 1030 }}>
            {/* Hamburger menu button */}
            <ul className="navbar-nav d-lg-none">
                <li className="nav-item">
                    <a className="nav-link" href="#" role="button" onClick={toggleSidebar} style={{ fontSize: '18px', padding: '8px 12px' }}>
                        <i className="fas fa-bars" />
                    </a>
                </li>
            </ul>

            {/* Logo and Brand Title Left */}
            <Link to="/" className="navbar-brand-custom">
                <img src="/img/logo.png" alt="108 Hospital Logo" />
                <div className="brand-text-container">
                    <span className="brand-title">QLTTKH</span>
                    <span className="brand-subtitle">VNCKHYDLS 108</span>
                </div>
            </Link>

            {/* Horizontal Navigation Menu */}
            <ul className="navbar-nav mr-auto d-none d-lg-flex">
                {/* Trang chủ */}
                <li className="nav-item">
                    <NavLink exact to="/" className="nav-link" activeClassName="active">
                        <i className="fas fa-home" /> Trang chủ
                    </NavLink>
                </li>

                {/* Khai báo Nhân viên */}
                {isEditor && (
                    <>
                        <li className="nav-item">
                            <NavLink to="/nhan-vien" className="nav-link" activeClassName="active">
                                <i className="fas fa-id-card" /> Thông tin chung
                            </NavLink>
                        </li>
                    </>
                )}


                {/* Giảng viên */}
                {!isEditor && (
                    <li className="nav-item">
                        <NavLink to="/profile-cv" className="nav-link" activeClassName="active">
                            <i className="fas fa-user-tie" /> Danh sách giảng viên
                        </NavLink>
                    </li>
                )}

                {/* Hoạt động nghiên cứu (Dropdown) */}
                {isEditorOrAdmin && (
                    <li 
                        className={`nav-item dropdown ${activeDropdown === 'research' ? 'show' : ''}`}
                        onMouseEnter={() => handleMouseEnter('research')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <span className="nav-link dropdown-toggle" style={{ cursor: 'pointer' }}>
                            <i className="fas fa-microscope" /> Hoạt động nghiên cứu
                        </span>
                        <div className={`dropdown-menu ${activeDropdown === 'research' ? 'show' : ''}`}>
                            <Link className="dropdown-item" to={isEditorOrAdmin ? "/bai-bao-cong-bo" : "/profile-cv?tab=baibao"}>
                                <i className="fas fa-newspaper" /> Các bài báo được công bố
                            </Link>
                            <Link className="dropdown-item" to={isEditorOrAdmin ? "/nhiem-vu-khcn" : "/profile-cv?tab=detai"}>
                                <i className="fas fa-flask" /> Nhiệm vụ khoa học và công nghệ
                            </Link>
                            <Link className="dropdown-item" to={isEditorOrAdmin ? "/sang-che" : "/profile-cv?tab=sangche"}>
                                <i className="fas fa-lightbulb" /> Sáng chế, giải pháp hữu ích
                            </Link>
                            <Link className="dropdown-item" to={isEditorOrAdmin ? "/giai-thuong" : "/profile-cv?tab=giaithuong"}>
                                <i className="fas fa-award" /> Giải thưởng về nghiên cứu khoa học
                            </Link>
                        </div>
                    </li>
                )}

                {/* Hoạt động đào tạo (Dropdown) */}
                {isEditorOrAdmin && (
                    <li 
                        className={`nav-item dropdown ${activeDropdown === 'training' ? 'show' : ''}`}
                        onMouseEnter={() => handleMouseEnter('training')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <span className="nav-link dropdown-toggle" style={{ cursor: 'pointer' }}>
                            <i className="fas fa-graduation-cap" /> Hoạt động đào tạo
                        </span>
                        <div className={`dropdown-menu ${activeDropdown === 'training' ? 'show' : ''}`}>
                            <Link className="dropdown-item" to={isEditorOrAdmin ? "/huong-dan-hoc-vien" : "/profile-cv?tab=huongdan"}>
                                <i className="fas fa-user-friends" /> Hướng dẫn học viên sau đại học
                            </Link>
                            <Link className="dropdown-item" to={isEditorOrAdmin ? "/giai-thuong-dao-tao" : "/profile-cv?tab=giaithuongdaotao"}>
                                <i className="fas fa-certificate" /> Giải thưởng về đào tạo
                            </Link>
                            <Link className="dropdown-item" to={isEditorOrAdmin ? "/sach" : "/profile-cv?tab=sach"}>
                                <i className="fas fa-book" /> Sách và giáo trình
                            </Link>
                        </div>
                    </li>
                )}
                {isEditor && (
                    <>
                        <li className="nav-item">
                            <NavLink to="/profile-cv" className="nav-link" activeClassName="active">
                                <i className="fas fa-university" /> Lý lịch khoa học
                            </NavLink>
                        </li>
                    </>
                )}

                {/* Quản lý Danh mục (Dropdown for SuperAdmin only) */}
                {isSuperAdmin && (
                    <li 
                        className={`nav-item dropdown ${activeDropdown === 'category' ? 'show' : ''}`}
                        onMouseEnter={() => handleMouseEnter('category')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <span className="nav-link dropdown-toggle" style={{ cursor: 'pointer' }}>
                            <i className="fas fa-list" /> Quản lý Danh mục
                        </span>
                        <div className={`dropdown-menu ${activeDropdown === 'category' ? 'show' : ''}`}>
                            <Link className="dropdown-item" to="/danh-muc-don-vi">
                                <i className="fas fa-building" /> Danh mục Đơn vị
                            </Link>
                            <Link className="dropdown-item" to="/danh-muc-hoc-vi">
                                <i className="fas fa-graduation-cap" /> Danh mục Học vị
                            </Link>
                            <Link className="dropdown-item" to="/danh-muc-chuc-danh-khoa-hoc">
                                <i className="fas fa-award" /> Danh mục Chức danh khoa học
                            </Link>
                            <Link className="dropdown-item" to="/danh-muc-chuc-vu">
                                <i className="fas fa-user-tag" /> Danh mục Chức vụ
                            </Link>
                        </div>
                    </li>
                )}

                {/* Hệ thống (Dropdown for Admin) */}
                {isAdmin && (
                    <li 
                        className={`nav-item dropdown ${activeDropdown === 'system' ? 'show' : ''}`}
                        onMouseEnter={() => handleMouseEnter('system')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <span className="nav-link dropdown-toggle" style={{ cursor: 'pointer' }}>
                            <i className="fas fa-cogs" /> Hệ thống
                        </span>
                        <div className={`dropdown-menu ${activeDropdown === 'system' ? 'show' : ''}`}>
                            <Link className="dropdown-item" to="/account">
                                <i className="fas fa-users-cog" /> Quản lý Tài khoản
                            </Link>
                            {isSuperAdmin && (
                                <>
                                    {/* <Link className="dropdown-item" to="/email-config">
                                        <i className="fas fa-envelope-open-text" /> Email gửi thông báo
                                    </Link> */}
                                    <Link className="dropdown-item" to="/log">
                                        <i className="fas fa-history" /> Xem log hệ thống
                                    </Link>
                                    <Link className="dropdown-item" to="/login-history">
                                        <i className="fas fa-chart-line" /> Báo cáo người dùng đăng nhập
                                    </Link>
                                </>
                            )}
                        </div>
                    </li>
                )}
            </ul>

            {/* Right side Profile menu & Mobile menu toggle */}
            <ul className="navbar-nav ml-auto align-items-center">
                <User />
            </ul>
        </nav>
    );
};

export default Header;
